<twc-navigation-bar [menuItems]="[]">
  <button
    panel-toggle
    mat-icon-button
    class="panel-toggle-button mr-4"
    aria-label="Toggle side navigation"
    [attr.aria-expanded]="sidebarState.expanded()"
    (click)="sidebarState.toggle()"
  >
    <mat-icon svgIcon="twc:panel"></mat-icon>
  </button>

  <twc-logo
    logo
    path="assets/images/Lighthouse.svg"
    darkPath="assets/images/DarkLighthouse.svg"
  ></twc-logo>

  <lig-global-search
    search
    *permissionSome="searchPermissions"
  ></lig-global-search>
</twc-navigation-bar>
